module.exports = __webpack_public_path__ + "assets/img/6.f037a601.jpg";